import type { PaletteColorOptions, PaletteOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  export interface PaletteOptions {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
    neutral?: PaletteColorOptions;
  }
  
  export interface Palette {
    neutral: PaletteColorOptions;
  }
}

export const palette: PaletteOptions = {
  primary: {
    main: "#3c3759", // Vibrant Purple
    light: "#5f5a7b",
    dark: "#2d2a42",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#068cc1", // Vibrant Blue
    light: "#39a3d1",
    dark: "#056a94",
    contrastText: "#ffffff",
  },
  neutral: {
    main: "#6e7178", // Neutral gray
    light: "#a6a9ae",
    dark: "#494c54",
    contrastText: "#ffffff",
  },
  background: {
    default: "#f5f5f5",
    paper: "#ffffff",
  },
  success: {
    main: "#4caf50", // Vibrant Green
    light: "#7bc67e",
    dark: "#3b8a3e",
  },
  warning: {
    main: "#ff9800", // Vibrant Orange
    light: "#ffb74d",
    dark: "#f57c00",
  },
  error: {
    main: "#f44336", // Vibrant Red
    light: "#f88078",
    dark: "#d32f2f",
  },
  info: {
    main: "#2196f3", // Vibrant Blue
    light: "#64b5f6",
    dark: "#1976d2",
  },
  text: {
    primary: "#3c3759", // Vibrant Purple
    secondary: "#0d6186", // Vibrant Blue
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  divider: "rgba(0, 0, 0, 0.12)",
};